import { GraphSchema } from '@camelot/server';
import { Address, Project, projectAddressProps, projectProps, tenantProps } from '@camelot/services';

import { Company } from '../../../organization/services/dto/company';
import { Department } from '../../../organization/services/dto/department';

export interface ProjectExtended extends Project {
  department?: Department;
  address?: Address;
  company?: Company;
  parentProject?: Project;
}

export const projectExtendedProps = new GraphSchema<ProjectExtended>([
  'id',
  'name',
  'status',
  'projectAddress',
  'tenantInformation',
  'projectPictureUrl',
  'pictureDocumentId',
  'contactId',
  'documentIds',
  'departmentId',
  'addressId',
  'contact',
  'department',
  'address',
  'company',
  'parentProject',
]);

export const nestedProjectProps: Record<string, string> = {
  [projectProps.get('projectAddress')?.toString() ?? '']: `${projectProps.get('projectAddress')} {
    ${projectAddressProps.get('id')}
    ${projectAddressProps.get('city')}
    ${projectAddressProps.get('street')}
    ${projectAddressProps.get('postCode')}
    ${projectAddressProps.get('country')}
  }`,
  [projectProps.get('tenantInformation')?.toString() ?? '']: `${projectProps.get('tenantInformation')} {
    ${tenantProps.get('id')}
    ${tenantProps.get('tenantName')}
    ${tenantProps.get('projectId')}
  }`,
};
